export enum MobilePlatformEnum {
  IOS = 'ios',
  ANDROID = 'android'
}

export class MobileAppUpdateInformationQueryDto {
  platform: MobilePlatformEnum;
  version: string;
}
